<template>
    <div>
        <SelectField name="type" :label="this.$t('component')" v-model="content.component_ref"
            :items="componentList"
            :rules="{required: true}"
            custom
        />

         <CodeEditor
                v-model="content.expression"
                :label="this.$t('code')"
                :label-cols="2"
                :horizontal="true"
                :libs="libs"
                :vars="vars"
                :snippets="snippets"
            />
    </div>
</template>

<script>
import SelectField from '@/components/form/Select'
import CodeEditor from '@/components/form/Editor/Code'

export default {
    components: {
        SelectField,
        CodeEditor
    },
    props: {
       value: {
         type: Object,
         default: function() {
             return {}
         }
       }
    },
    computed: {
        content: {
            get() {
                return this.value || {};
            },

            set(val) {
                //console.log(val)
                this.$emit('input', val);
            }
        },

        componentList() {
            let cm = this.$store.getters.componentsMenu
            let currentComponent = this.$store.getters.currentComponent

            cm.map(el => {
                el.text = el.name
                el.value = el.name
            })

            let filtered = cm.filter(el => {
                return el.name != currentComponent.name && el.is_active
            })

            if (filtered.length < 1) {
                return [
                    {
                        text: "No active component",
                        value: null
                    }
                ]
            }

            return filtered
        },

        libs() {
            return [
                {
                    name: "lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                },
                {
                    name: "protokol/component",
                    varName: "component",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-component"
                },
                {
                    name: "protokol/io",
                    varName: "io",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-io"
                }
            ]
        },

        vars() {
            return []
        } ,
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        save() {
            this.modal.show = false
        },

        modelFields() {
            let componentUuid = this.content.component_uuid

            console.log

            let component = this.$store.getters.componentSettings(componentUuid)
            let fields = component.settings.fields

            let formated = {}

            if (fields !== null) {
                fields.forEach(f => {
                    formated[f.key] = null

                    if (f.module == "input" || f.module == "textarea") {
                        formated[f.key] = ""

                        if (f.type == "number") {
                            formated[f.key] = 0
                        }
                    }
                })
            }

            return JSON.stringify(formated)
        }
    },
    data: function() {
        return {
            errors: [],
            modal: {
                show: false
            },

            snippets: [
                {text: 'component.setFilters({})', displayText: 'component.setFilters()', info: 'Set specific filters to filter our models for component.', docs: this.$env.get('DOCS_URL') + "/docs#libs-component"},
                {text: 'component.create({})', displayText: 'component.create()', info: 'Creates model inside component with provided fields.'},
                {text: 'component.update({})', displayText: 'component.update()', info: 'Update models for component that match filters set with <i>setFilters()</i> method.'},
                {text: 'io.getPipedDataOf(nodeName)', displayText: 'io.getPipedDataOf(nodeName)', info: 'Get piped data of another node that executed before this node.', docs: this.$env.get('DOCS_URL') + "/docs#libs-io"},
                {text: 'io.pipe(data)', displayText: 'io.pipe(data)', info: `Pipe data so other nodes that executes after this node can use it.`, docs: this.$env.get('DOCS_URL') + "/docs#libs-io"}
            ]
        }
    },

    mounted() {

    }
}
</script>
